import { inject, Injectable } from "@angular/core";
import { activeEvents, focusEvents, keyboardEvents, miscellaneousEvents, touchEvents } from "@auth/static/events";
import { AuthService } from "@auth/services/auth/auth.service";

@Injectable({
    providedIn: "root",
})
export class InactivityService {
    private intervalId: any;
    private refreshTokenInterval: number = 30 * 60000; // 30 minutes

    private readonly authService = inject(AuthService);

    constructor() {
        this.setupInactivityListener();
    }

    private setupInactivityListener() {
        this.resetInterval();

        const events = activeEvents.concat(focusEvents, touchEvents, keyboardEvents, miscellaneousEvents);
        events.forEach((event) => document.addEventListener(event, () => this.resetInterval(), true));
    }

    private resetInterval() {
        clearInterval(this.intervalId);
        this.intervalId = setInterval(() => this.authService.logout(), this.refreshTokenInterval);
    }
}
